import { render, staticRenderFns } from "./email-dialog.vue?vue&type=template&id=ed7041a6&scoped=true"
import script from "./email-dialog.vue?vue&type=script&lang=ts"
export * from "./email-dialog.vue?vue&type=script&lang=ts"
import style0 from "./email-dialog.vue?vue&type=style&index=0&id=ed7041a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7041a6",
  null
  
)

export default component.exports